import { TFunction } from 'i18next';
import { DeepReadonlyObject } from 'rxdb';

import { ItineraryView } from '@mopla/data-models';

import { getItineraryTimingV2 } from '../itinerary';

export interface IOptions {
	withAround?: boolean;
}

export const getFromToString = (
	itinerary: DeepReadonlyObject<ItineraryView>,
	t: TFunction,
	options?: IOptions
): string => {
	const { withAround = false } = options || {};

	const { effectiveStartTime, effectiveEndTime } = getItineraryTimingV2(
		itinerary.legs
	);

	return [
		withAround && t('common:text.around'),
		`${effectiveStartTime} - ${effectiveEndTime}`,
	]
		.filter(Boolean)
		.join(' ');
};
